import React from "react";
import { useProductionStore } from "../../../stores/production";
import { formatComptableMaisPasTrop } from "../../../services/function";

const Payments = ({ sortedPayments }: { sortedPayments: any }) => {
  const { production2 } = useProductionStore();

  return (
    <table className="min-w-full font-Nunito bg-white shadow-lg border border-gray-100 rounded-2xl h-auto overflow-x-scroll overflow-y-scroll">
        <React.Fragment>
          <thead className="w-full border border-gray-300 px-4 py-2  text-left">
            <tr className="h-12">
              <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
                Date
              </th>
              <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
                Numéro Facture
              </th>
              <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
                Montant Sur Facture
              </th>
              <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
                Montant Encaissement
              </th>
              <th className="border border-gray-300 px-4 py-2 bg-thead text-left">
                Montant TVA
              </th>
            </tr>
          </thead>
          <tbody>
            {sortedPayments?.map((payment: any, index: any) => (
              <tr key={index} className="h-8 border-gray-300">
                <td className="border border-gray-300 px-4 py-2 text-left">
                  {payment.date}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-left">
                  {payment.invoiceNumber}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-left">
                  {formatComptableMaisPasTrop(payment.amountApplied)}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-left">
                  {formatComptableMaisPasTrop(payment.amount)}
                </td>
                <td className="border border-gray-300 px-4 py-2 text-left">
                  {formatComptableMaisPasTrop(payment.amountVAT)}
                </td>
              </tr>
            ))}
          </tbody>
        </React.Fragment>
      <tfoot>
        <tr className="border-gray-300 bg-gray-200 h-8 w-full">
          <td className="border border-gray-300 px-4 py-2 text-left w-44">
            Total des totaux
          </td>
          <td className="border border-gray-300 px-4 py-2 text-left"></td>
          <td className="border border-gray-300 px-4 py-2 text-left font-bold">
            {formatComptableMaisPasTrop(production2?.totalApplied)}
          </td>
          <td className="border border-gray-300 px-4 py-2 text-left font-bold">
            {formatComptableMaisPasTrop(
              production2?.total
            )}
          </td>
          <td className="border border-gray-300 px-4 py-2 text-left font-bold">
            {formatComptableMaisPasTrop(production2?.totalVAT)}
          </td>
        </tr>
      </tfoot>
    </table>
  );
}

export default Payments